import { ISetVehicleImages } from "../interfaces/garage.interface";

function setVehicleImages(data: { small: string; medium: string; large: string, angle?: string }): ISetVehicleImages {
  return {
    type: "SET_VEHICLE_IMAGES",
    data,
  };
}
export default setVehicleImages;
